import { createContext } from 'react';

const AccessManagerDispatchContext = createContext();

export default AccessManagerDispatchContext;
